import { useMemo } from 'react';

export const useVariantPopupController = ({
  // Popup State
  variantPopup,

  // Handlers
  setVariantPopup,
  handleApplyVariant,
  handlePreviewVariant,
  handleRestoreVariant,
  handleVariantChange,
  handleDisabledChange,

  // Data
  activeNodes,
  effectiveBreakpoint,
  variantManager
}) => {
  const controller = useMemo(() => {
    if (!variantPopup) return null;

    return {
      // Position
      x: variantPopup.x,
      y: variantPopup.y,

      // Data
      componentType: variantPopup.componentType,
      previewNode: activeNodes.find(n => n.id === variantPopup.node?.id) || variantPopup.node,
      appliedVariant: variantManager.appliedVariant,
      activeBreakpoint: effectiveBreakpoint,

      // Handlers
      onClose: () => setVariantPopup(null),
      onApply: handleApplyVariant,
      onPreview: handlePreviewVariant,
      onRestore: handleRestoreVariant,
      onVariantChange: handleVariantChange,
      onDisabledChange: handleDisabledChange
    };
  }, [
    variantPopup,
    activeNodes,
    effectiveBreakpoint,
    variantManager,
    setVariantPopup,
    handleApplyVariant,
    handlePreviewVariant,
    handleRestoreVariant,
    handleVariantChange,
    handleDisabledChange
  ]);

  return controller;
};
